import React, { useState } from 'react';

// Utils
import { MESSAGES } from '~/utils/message';

// Components
import Loader from '../../../General/Loader';
import OlcFormModal from '~/components/General/OlcFormModal';

// MUI Components
import { Box, IconButton, Typography, List, ListItem, Tooltip } from '@mui/material';

// Icons
import CopyIcon from '@mui/icons-material/ContentCopy';
import ExternalLinkIcon from '@mui/icons-material/OpenInNew';
import CheckIcon from '@mui/icons-material/Check';
import LinkIcon from '@mui/icons-material/Link';

// Styles
import './styles.scss';

const LinksModal = (props) => {
  const { open, onClose, batchId, loading, accutraceLinks } = props;
  const [copiedId, setCopiedId] = useState(null);

  const copyToClipboard = async (url, id) => {
    try {
      await navigator.clipboard.writeText(url);
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 2000);
    } catch (err) {
      return err;
    }
  };

  const openLink = (url) => {
    window.open(url, '_blank');
  };

  return (
    <OlcFormModal
      open={open}
      onClose={onClose}
      title={`${MESSAGES.ADMIN_DASHBOARD.BATCHES.BATCH_LINK_HEADER}${batchId}`}
      className="olcAdminFormModal linksModal"
      dialogProps={{ maxWidth: false, fullWidth: true }}
    >
      <Box className="linksModal__headerIcon">
        <LinkIcon className="linksModal__linkIcon" />
      </Box>
      {loading ? (
        <Loader />
      ) : (
        <List className="linksModal__list">
          {accutraceLinks?.map((link, index) => (
            <Box key={index} className="linksModal__itemWrapper">
              <ListItem className="linksModal__listItem">
                <Box className="linksModal__accentBar" />
                <Box className="linksModal__itemContent">
                  <Box className="linksModal__itemTop">
                    <Typography className="linksModal__linkText">{link}</Typography>
                    <Box className="linksModal__actions">
                      <Tooltip title={copiedId === index ? 'Copied!' : 'Copy link to clipboard'}>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            copyToClipboard(link, index);
                          }}
                          className={`linksModal__iconButton ${copiedId === index ? 'copied' : ''}`}
                        >
                          {copiedId === index ? (
                            <CheckIcon fontSize="small" />
                          ) : (
                            <CopyIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Open link in new tab">
                        <IconButton
                          size="small"
                          onClick={() => openLink(link)}
                          className="linksModal__iconButton secondary"
                        >
                          <ExternalLinkIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                </Box>
              </ListItem>
            </Box>
          ))}
        </List>
      )}
    </OlcFormModal>
  );
};

export default LinksModal;
